import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ServiceCallSummaryComponent } from './service-call-summary';
import { ServiceCallDetailComponent } from './service-call-detail';
import { ServiceCallEditComponent } from './service-call-edit';
import { ServiceCallCreateComponent } from './service-call-create';
import { ServiceCallPdfSummaryComponent } from './service-call-pdf-summary/service-call-pdf-summary.component';
import { ServiceCallPdfAddComponent } from './service-call-pdf-add/service-call-pdf-add.component';
import { Authguard } from '../../../helper';
import { Roles } from '../../../model';

const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'Service Call'
    },
    children: [
      {
        path: 'summary',
        component: ServiceCallSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'summary/:customerId',
        component: ServiceCallSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'detail/:id',
        component: ServiceCallDetailComponent,
        data: { title: 'Details' }
      },
      {
        path: 'edit/:id',
        component: ServiceCallEditComponent,
        data: { title: 'Edit' }
      },
      {
        path: 'add',
        component: ServiceCallCreateComponent,
        canActivate: [ Authguard ],
        data: {
          title: 'Add' ,
          permission: {
            role: [Roles.Admin, Roles.Engineer],
            redirectTo: '403'
          }
        }
      },
      {
        path: 'add/cu/:id',
        component: ServiceCallCreateComponent,
        canActivate: [ Authguard ],
        data: {
          title: 'Add' ,
          permission: {
            role: [Roles.Admin, Roles.Engineer],
            redirectTo: '403'
          }
        }
      },
      {
        path: 'add/ec/:id',
        component: ServiceCallCreateComponent,
        canActivate: [ Authguard ],
        data: {
          title: 'Add' ,
          permission: {
            role: [Roles.Admin, Roles.Engineer],
            redirectTo: '403'
          }
        }
      },
      {
        path: 'add/pm/:id',
        component: ServiceCallCreateComponent,
        canActivate: [ Authguard ],
        data: {
          title: 'Add' ,
          permission: {
            role: [Roles.Admin, Roles.Engineer],
            redirectTo: '403'
          }
        }
      },
      {
        path: 'add/sc/:id',
        component: ServiceCallCreateComponent,
        canActivate: [ Authguard ],
        data: {
          title: 'Add' ,
          permission: {
            role: [Roles.Admin, Roles.Engineer],
            redirectTo: '403'
          }
        }
      },
      {
        path: 'pdf/:id', 
        data: { title: 'PDF'},
        children: [{
          path: 'a',
          component: ServiceCallPdfAddComponent,
          data: { title: 'Upload PDF' }
        }, {
          path: '',
          component: ServiceCallPdfSummaryComponent,
        }],
       
      }      
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceCallRoutingModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-routing.module.ts